import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
var SvgNoActivities = function SvgNoActivities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 197,
    viewBox: "0 0 216 197",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M37.396 191.481c-2.738.533-5.392-1.265-5.926-4.015L3.448 43.309c-.534-2.75 1.253-5.411 3.991-5.943l121.621-23.64c2.738-.533 5.392 1.264 5.926 4.014l28.022 144.158c.518 2.666-1.146 5.249-3.745 5.888l-.246.055-121.62 23.64z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.172 188.274c-1.857.361-3.65-.832-4.007-2.665L6.619 43.896c-.238-1.222.573-2.407 1.811-2.648l120.044-23.334c1.857-.361 3.652.832 4.008 2.665l27.546 141.713c.238 1.222-.573 2.407-1.811 2.648L38.172 188.274z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.793 182.282c-1.683.328-3.315-.784-3.645-2.483L13.622 48.479a2.08 2.08 0 011.633-2.445l108.79-21.147c1.683-.327 3.315.785 3.645 2.483l25.526 131.321a2.08 2.08 0 01-1.633 2.445l-108.79 21.146z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.793 182.282c-1.683.328-3.315-.784-3.645-2.483L13.622 48.479a2.08 2.08 0 011.633-2.445l108.79-21.147c1.683-.327 3.315.785 3.645 2.483l25.526 131.321a2.08 2.08 0 01-1.633 2.445l-108.79 21.146z",
    fill: "#fff",
    fillOpacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M49.273 170.836c-1.436.279-2.836-.703-3.125-2.194L23.743 53.382c-.193-.994.427-1.95 1.384-2.136l92.847-18.048c1.436-.28 2.836.703 3.125 2.194l22.405 115.26c.193.993-.427 1.95-1.384 2.136l-92.847 18.048z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "6 5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.705 52.97a3.6 3.6 0 01-4.221-2.848L40.507 34.81a3.6 3.6 0 012.847-4.22l11.828-2.3c-.812-7.371 4.158-14.255 11.569-15.696 7.41-1.44 14.597 3.08 16.606 10.22l11.827-2.3a3.6 3.6 0 014.221 2.847l2.977 15.314a3.6 3.6 0 01-2.847 4.22L47.705 52.97z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.836,
    cy: 25.941,
    r: 3.5,
    transform: "rotate(-11 68.836 25.94)",
    fill: "#fff",
    fillOpacity: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.988,
    cy: 152.223,
    r: 44,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.988,
    cy: 152.223,
    r: 44,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.988,
    cy: 152.223,
    r: 35.415,
    fill: "#fff",
    fillOpacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.488 171.723v-39M153.381 152.223l37.107-.5",
    stroke: "currentColor",
    strokeWidth: 7,
    strokeLinecap: "round"
  }));
};
export default SvgNoActivities;